import { Container, Group, Skeleton } from '@mantine/core';
import { chatContainerSize, Cmp } from '~portal/lib';
import * as styles from './ChatInput.css';

/**
 * @desc The composer's placeholder while a conversation is being fetched.
 *
 * It exists so the composer is ALWAYS on screen: previously the whole input area was withheld
 * until the fetch resolved and then popped in, shoving the transcript up by its own height. The
 * geometry is not reproduced here but reused — the same container and pill classes, and the same
 * height token the real Textarea is given (`composerLineHeight`) — so "same box" is a property
 * of the stylesheet rather than of two numbers someone has to keep in step.
 */
export const ChatInputSkeleton: Cmp = function () {
  return (
    <Container
      size={chatContainerSize}
      className={styles.inputContainer}
      data-testid="composer-skeleton"
    >
      <Group gap="xs" className={styles.inputGroup} wrap="nowrap" align="flex-end">
        <Skeleton className={styles.skeletonLine} radius="xl" />
        <Group gap={4} wrap="nowrap" className={styles.trailingControls}>
          <Skeleton circle height={styles.sendButtonSize} width={styles.sendButtonSize} />
        </Group>
      </Group>
    </Container>
  );
};
